import * as React from 'react';
import { createRoot } from 'react-dom/client';

import BaseModule from '../../../javascripts/helpers/baseModule';

import Root from './containers/Root.tsx';

export default class Survey extends BaseModule {
  constructor(element) {
    super(element, 'survey');

    this.getElements([
      { id: 'config', selector: 'config' },
      { id: 'app', selector: 'app' }
    ]);

    const config = JSON.parse(this.elements.config.textContent);

    const root = createRoot(this.elements.app);
    root.render(<Root config={config} />);
  }
}
